import React, { useEffect } from 'react';
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgStageImage from '../../assets/management/StageImage.jpg';
import ContactBubble from '../../Components/ContactBubble/ContactBubble';
import imgMarianne from '../../assets/management/DSC_6123.jpg';
import imgSebastian from '../../assets/management/Sebastian Schrader.jpg';
// import imgAlistair from '../../assets/management/DSC_6008.jpg';


function Management() {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    return (
        <div>
            <CenterStage title={"Meet our Management"} imageSrc={imgStageImage} paragraph={"At HANSA-FLEX, our management is influential in guiding the company with strategic vision and operational excellence. Through dynamic leadership and a focus on innovation, we prioritize customer satisfaction and sustainable growth. Our management fosters a culture of collaboration and empowerment, driving success across all facets of the organization."} />

            <div>
                <ContactBubble
                    imageSrc={imgSebastian}
                    title="Sebastian Schrader"
                    subTitle="Managing Director"
                    description="Sebastian Schrader, our influential Managing Director, leads with strategic vision, fostering growth and innovation. With a wealth of experience, he drives excellence across our organization, ensuring success and customer satisfaction."
                />
                    {/* description="Sebastian Schrader, our Managing Director, is a visionary leader with over 23 years of experience in the industry. He excels in strategic planning and operational management, driving innovation and growth. His commitment to customer satisfaction and team empowerment has transformed our organization, making it a leader in the market." */}
                    {/* description="Sebastian Schrader, our Managing Director, brings strategic vision and extensive industry expertise to HANSA-FLEX Brazil Ltd. His leadership drives innovation, operational excellence, and customer satisfaction, ensuring we remain a trusted partner for hydraulic solutions." */}

                {/* <ContactBubble
                    imageSrc={imgMarianne}
                    title="Marianne Schmitt"
                    subTitle="Operations Director"
                    description="Marianne Schmitt, our esteemed Operations Director, drives operational excellence with dedication and precision. With her leadership, we optimize processes, ensuring efficiency and delivering exceptional results to our valued customers."
                /> */}
            </div>
        </div>
    );
}

export default Management;